import { render } from "./AIPersonalizationModal.vue?vue&type=template&id=b2babebc&scoped=true&ts=true"
import script from "./AIPersonalizationModal.vue?vue&type=script&lang=ts"
export * from "./AIPersonalizationModal.vue?vue&type=script&lang=ts"

import "./AIPersonalizationModal.vue?vue&type=style&index=0&id=b2babebc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2babebc"]])

export default __exports__